import { ReactElement, useRef, useState } from "react";
import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Tooltip,
  IconButton,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import DataObjectIcon from "@mui/icons-material/DataObject";
import CodeIcon from "@mui/icons-material/Code";
import TableRowsIcon from "@mui/icons-material/TableRows";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { FormatType } from "../types";


interface IProps {
  enabled: boolean;
  formats: FormatType[];
  onExportFormat: (format: FormatType) => void;
}

const ExportButton = ({ formats, onExportFormat, enabled }: IProps): ReactElement => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  const handleToggle = () => setOpen((prevOpen) => !prevOpen);
  const onClickAway = () => setOpen(false);

  return (
    <>
      <Tooltip title="Export">
        <span>
          <IconButton ref={anchorRef} color="success" onClick={handleToggle} disabled={!enabled} >
            <GetAppIcon/>
          </IconButton>
        </span>
      </Tooltip>

      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition={true} disablePortal={true} style={{ zIndex: 999 }}>
        {({ TransitionProps, placement }) =>
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === "bottom" ? "center top" : "center bottom" }}
          >
            <Paper>
              <ClickAwayListener onClickAway={onClickAway}>
                <MenuList autoFocusItem={open} id="menu-list-grow">
                  { formats.map(format => {

                    return (
                      <MenuItem key={`export-${format.toLowerCase()}`} onClick={() => onExportFormat(format)}>
                        <ListItemIcon>
                          {format === "JSON" && <DataObjectIcon fontSize="small"/>}
                          {format === "XML" && <CodeIcon fontSize="small"/>}
                          {format === "CSV" && <TableRowsIcon fontSize="small"/>}
                          {format === "PDF" && <PictureAsPdfIcon fontSize="small"/>}
                        </ListItemIcon>
                        <ListItemText>{format}</ListItemText>
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        }
      </Popper>
    </>
  );
};

export default ExportButton;